import { getCurrentChatSessionInfo as n } from "./chat-session-storage.js";
import { CONVERSATION_END_THRESHOLD as o } from "../constants.js";
function a(e) {
  const t = n(e);
  return !t || !t.lastMessageSentAt ? !1 : Date.now() - t.lastMessageSentAt < o;
}
export {
  a as shouldContinueConversation
};
